import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Form,
  Select,
  Modal,
  Collapse,
  DatePicker,
} from "antd";
import Container from "../../../../components/user/Container";
import { changeFormatdate } from "../../../../utils/formatdate";
import { numberWithCommas } from "../../../../utils/number";
import { alertMessage } from "../../../../utils/message";
import { UrlAbstainTime, getToken } from "../../../../utils/auth";
import { typeDataLink } from "../../../../utils/welfareList";
import axios from "axios";
import { apiKeyNews } from "../../../../utils/apiKey";
import axiosI3 from "../../../../config/axios-i3";
import { checkLinkURL } from "../../../../utils/auth";
import ModalConfirmForm from "../../../../components/user/ModalConfirmForm";
import moment from "moment";
import { urlBenefit } from "../../../../utils/auth";
import InputDateStartEnd from "../../../../components/user/from/InputDateStartEnd";

const { Text, Title } = Typography;
const { Option } = Select;
const { Panel } = Collapse;
class Dashboard extends Component {
  // formRef = React.createRef();
  formPDF = React.createRef();
  state = {
    // loading: true,
    // loadingFullpage: true,
    preLoadSubmit: false,
    showModalExportPDF: false,
    loadingFullpage: false,
    loading: true,
    dateSelectModal: {
      startDate: null,
      endDate: null,
    },
    dropdownWelfareType: [
      // { value: "", label: "ทั้งหมด" },
      // { value: "Disater", label: "ช่วยเหลือประสบภัยพิบัติ" },
      // { value: "Scholarship", label: "เบิกค่าธรรมเนียมการศึกษา" },
    ],
    dataTemp: {
      rowTableId: "1",
      noTable: "202211-01",
      id: "83b87f22-c31c-4e11-88f3-5b8895fbeba6",
      empCodeTable: "5590113",
      nameTable: "นางสาวกฐฟอ  กกงฬมปัขิ",
      orgTable: "ศูนย์บริการโลหิตแห่งชาติ",
      departmentTable: "ศูนย์บริการโลหิตแห่งชาติ-ฝ่ายจัดซื้อและพัสดุ",
      departmentNameTable: "งานบริหารสวัสดิการ",
      moneyPaymentsReceiptTable: "85000",
      moneyPaymentsTable: "85000",
      welfareType: "studyPayment",
      statusTable: "อนุมัติ",
    },

    dataTalbe: [
      // {
      //   rowTableId: "1",
      //   noTable: "202211-01",
      //   documentNo: "202211-01",
      //   empCode: "5590113",
      //   name: "นางสาวกฐฟอ  กกงฬมปัขิ",
      //   typeTable: "studyPayment",
      //   status: "pending",
      // },
      // {
      //   rowTableId: "2",
      //   noTable: "202211-01",
      //   documentNo: "202211-01",
      //   empCode: "5590113",
      //   name: "นางสาวกฐฟอ  กกงฬมปัขิ",
      //   typeTable: "paymentVictim",
      //   status: "pending",
      // },
    ],
    selectStatus: "",
    columns: [
      // {
      //   title: () => {
      //     return (
      //       <Checkbox
      //         disabled={
      //           this.state.selectStatus == "pending" ||
      //           this.state.selectStatus == ""
      //             ? false
      //             : true
      //         }
      //         checked={this.state.checkBoxTitle}
      //         // className="checkBox-select"
      //         onChange={(e) => this.onChangeSlectAll(e.target.checked)}
      //       ></Checkbox>
      //     );
      //   },
      //   dataIndex: "statusCheckBox",
      //   width: 90,
      //   align: "center",
      //   render: (item, record, index) => {
      //     return (
      //       <Checkbox
      //         // className="checkBox-select"
      //         checked={item}
      //         disabled={record.status == "pending" ? false : true}
      //         onChange={(e) =>
      //           this.onChangeSlectTable(
      //             e.target.checked,
      //             record.approverId,
      //             index,
      //             record
      //           )
      //         }
      //       ></Checkbox>
      //     );
      //   },
      // },
      {
        // title: 'เลขที่เอกสาร',
        title: "เลขที่เอกสาร",
        dataIndex: "documentNo",
        width: 160,
        align: "center",
        render: (item, record, index) => <span>{item ?? '-'}</span>,
        // render: (item, record, index) => <span>{ item }</span>
      },
      {
        // title: 'เลขที่เอกสาร',
        title: "รหัสบุคลากร",
        dataIndex: "empCode",
        width: 120,
        render: (item, record, index) => <span>{item ?? '-'}</span>,
        align: "center",
      },
      {
        // title: 'เลขที่เอกสาร',
        title: "ชื่อ-นามสกุล",
        dataIndex: "empName",
        width: 200,
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },

      {
        title: "สำนัก",
        dataIndex: "orgName",
        width: 250,
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
      {
        title: "ฝ่าย",
        dataIndex: "diviName",
        width: 250,
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
      {
        title: "หน่วยงาน",
        dataIndex: "deptName",
        align: "center",
        width: 200,
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
      {
        title: "ประเภทสวัสดิการ",
        dataIndex: "welfareTypeName",
        align: "center",
        width: 200,
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
      {
        title: "รายละเอียดการเบิก",
        dataIndex: "welfareDetail",
        align: "center",
        width: 150,
        render: (item, record, index) => <span>{item ?? '-'}</span>,
      },
      {
        title: "จำนวนเงินเบิกตามระเบียบ",
        dataIndex: "totalWithdraw",
        align: "center",
        width: 120,
        render: (item, record, index) => <span>{item ? numberWithCommas(item) : '-'}</span>,
      },
      {
        title: "จำนวนเงินที่ได้รับอนุมัติ",
        dataIndex: "totalCurrentWithdraw",
        align: "center",
        width: 120,
        render: (item, record, index) => <span>{item ? numberWithCommas(item) : '-'}</span>,
      },
      {
        title: "วันที่ยื่นเรื่อง",
        dataIndex: "submitDate",
        width: "150px",
        align: "center",
        width: 200,
        render: (item, record, index) => (
          <span>{item ? changeFormatdate(moment(item)) : '-'}</span>
        ),
      },
      {
        title: "สถานะ",
        dataIndex: "welfareStatusName",
        align: "center",
        // render: (item, record, index) => <span>{}</span>
        width: 100,
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },

      {
        title: "จัดการ",
        dataIndex: "7",
        align: "center",
        width: 100,
        fixed: "right",
        render: (item, record, index) => {
          return (
            <>
              <Link
                to={{
                  pathname:
                    // "/welfare/welfareApproveList/form/" +
                    // typeDataLink(record.welfareType) +
                    // "/" +
                    // record.id,
                    "/welfare/welfareApproveList/form/" +
                    typeDataLink(record.welfareType) +
                    "/" +
                    record.id,
                  state: {
                    approverId: record.documentNo,
                    statusForm: record.welfareStatus,
                    isApproveMode: true,
                  },
                }}
              >
                <Icon type="form" className="mr-2" style={{ color: "#000" }} />
              </Link>
            </>
          );
        },
      },
    ],
    pageData: {
      page: 1,
      pageSize: 10,
    },
    // page: 1,
    // pageSize: 10,
    pagination: {
      total: 10,
    },
    disabledDateStart: moment(new Date()).add(-1, "year"),
    endStartValues: moment(new Date()).add(1, "year"),
    valueStatus: "A",
    preLoadSubmit: false,
    formValue: null,
    dropdownLeaveType: [],
    currentPage: 1,
    loginPerson: [],
    dataSelectTable: [],
  };

  onChangeSlectAll = async (value) => {
    const { dataTalbe } = this.state;
    let arrayNewsDataTable = [];
    const rowsDataSelectTable = [];
    const rows = null;
    // console.log('arrayNewsDataTable', dataTalbe)
    if (value) {
      await dataTalbe.map((values, keys) => {
        if (values.status == "pending") {
          values.statusCheckBox = value;
          arrayNewsDataTable[keys] = values;
          rowsDataSelectTable.push({
            approverId: values.approverId,
            abTimeHdId: values.relatedDocId,
          });
        } else {
          values.statusCheckBox = false;
          arrayNewsDataTable[keys] = values;
        }
      });
    } else {
      await dataTalbe.map((values, keys) => {
        values.statusCheckBox = value;
        arrayNewsDataTable[keys] = values;
      });
    }

    await this.setState({
      dataTalbe: arrayNewsDataTable,
      dataSelectTable: rowsDataSelectTable,
      checkBoxTitle: value,
    });
  };

  onChangeSlectTable = async (values, approverId, arrayId, record) => {
    let dataSourceitems = [...this.state.dataSelectTable];
    let keysdataSelectTable = null;

    let dataSourceitemsTable = [...this.state.dataTalbe];
    let item = { ...dataSourceitemsTable[arrayId] };
    item.statusCheckBox = values;

    dataSourceitemsTable[arrayId] = item;

    await this.setState(
      {
        dataTalbe: dataSourceitemsTable,
      },
      () => {
        // this.cllBackSetValueContactNumber()
      }
    );

    dataSourceitems.map(async (filtereditem, keys) => {
      if (filtereditem.approverId == approverId) {
        keysdataSelectTable = keys;
      }
    });

    if (values) {
      const rows = {
        approverId: record.approverId,
        abTimeHdId: record.relatedDocId,
      };
      await this.setState(
        (prevState) => ({
          dataSelectTable: [...prevState.dataSelectTable, rows],
        }),
        () => {
          // this.cllBackSetValueOrganizatuions()
        }
      );
    } else {
      dataSourceitems
        .filter((item) => item.approverId == approverId)
        .map((filtereditem) => {
          var arrayDataSource = [...this.state.dataSelectTable];
          arrayDataSource.splice(keysdataSelectTable, 1);

          this.setState(
            {
              dataSelectTable: arrayDataSource,
            },
            () => {
              // this.cllBackSetValueContactNumber()
            }
          );
        });
    }
  };

  fetchProfile = async () => {
    try {
      const { client } = this.props;

      const { data } = await client.query({
        query: Queries.fetchProfile,
      });

      await this.setState({
        loginPerson: data.fetchProfile,
        employeeCodes: data.fetchProfile.employeeCodes[0],
      });
      // return data.fetchProfile

      if (data.fetchProfile) {
        try {
          //await this.getAbstainTimeForApproverList(data.fetchProfile.employeeCodes[0])
        } catch (e) {}
      } else {
      }
    } catch (e) {}
  };

  paginationChange = async (e) => {
    const { formValue, empCode, valueSearch } = this.state;
    const { form, afterSubmit, client } = this.props;
    // await e.preventDefault()

    // console.log("pagination e",e)
    // console.log("pagination values",values)
    let page = 0;
    if (e.current === 1) {
      page = 1;
    } else {
      page = e.current;
      //+ "0";
    }

    await this.setState({
      pageData: {
        page: parseInt(page),
        pageSize: 10,
      },
    });
    await this.setState({
      pageData: {
        page: parseInt(page),
        pageSize: 10,
      },
      currentPage: e.current,
    });

    // await this.fetchListPost()
    if (valueSearch) {
      // console.log("paginationChange formvalue!!", values);
      await this.listBenefitForApproverSearch();
    } else {
      await this.listBenefitForApprover();
    }
  };

  listBenefitForApprover = async () => {
    const { token } = getToken();
    const { client, location, match } = this.props;
    const { page, pageSize, employeeCodes, pageData, dataTemp, valueSearch } =
      this.state;

    await this.setState({
      loading: true,
    });

    // let searchKeyword ={
    //    empCode :loginPerson.employeeCodes[0],
    // }
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    let config = {
      headers,
      params: {
        ...pageData,
        ...valueSearch,
        isApprover: true,
        approverEmpCode: employeeCodes,
      },
    };

    await axios
      .get(`${urlBenefit()}approveDisaster/listBenefitForApprover`, config)
      .then(async (response) => {
        console.log("response.data", response.data);
        if (response.data) {
          //response.data.welfareList.push(dataTemp)
          await this.setState({
            dataTalbe: response.data.welfareList,
            dataTalbeTotalAll: response.data.count,
            loadingFullpage: false,
            loading: false,
            pagination: {
              total: response.data.count,
            },
          });
        }
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  listBenefitForApproverSearch = async (e) => {
    const { token } = getToken();
    const { form, afterSubmit, client } = this.props;
    const { page, pageSize, employeeCodes, pageData, valueSearch } = this.state;

    //await e.preventDefault();
    form.validateFields(async (err, values) => {
      console.log("listBenefitForApproverSearch", values);
      const API_DEVICE_KEY = atob(apiKeyNews());

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        apiKey: API_DEVICE_KEY,
      };

      let config = {
        headers,
        params: {
          //...values,
          ...valueSearch,
          ...pageData,
          //empCode: employeeCodes, //employeeCodes
          isApprover: true,
          approverEmpCode: employeeCodes,
        },
      };
      await axios
        .get(`${urlBenefit()}approveDisaster/listBenefitForApprover`, config)
        .then(async (response) => {
          console.log("response.data", response.data);
          if (response.data) {
            // let arrayTempOtherWelfare = [{
            //    documentNo : "อื่นๆ",
            //   welfareType : "otherWelfare",
            //   id: "93"

            // }
            // ];

            // let arrayTemp =   response.data.welfareList.concat(arrayTempOtherWelfare)

            await this.setState({
              dataTalbe: response.data.welfareList,
              //dataTalbe: arrayTemp,
              dataTalbeTotalAll: response.data.count,
              loadingFullpage: false,
              loading: false,
              //currentPage: 1,
            });
          }
        })
        .catch((error) => console.error(`Error: ${error}`));
    });
  };

  listBenefitForApproverSearchPagi = async (e) => {
    const { token } = getToken();
    const { form, afterSubmit, client } = this.props;
    const { page, pageSize, employeeCodes, pageData } = this.state;

    await e.preventDefault();
    form.validateFields(async (err, values) => {
      console.log("listBenefitForApproverSearch", values);
      const API_DEVICE_KEY = atob(apiKeyNews());

      await this.setState({
        valueSearch: values,
        loading: true,
      });

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        apiKey: API_DEVICE_KEY,
      };

      let config = {
        headers,
        params: {
          // empCode: "5640056", //employeeCodes
          ...values,
          page: 1,
          pageSize: 10,
          isApprover: true,
          approverEmpCode: employeeCodes,
        },
      };
      await axios
        .get(`${urlBenefit()}approveDisaster/listBenefitForApprover`, config)
        .then(async (response) => {
          console.log("response.data", response.data);
          if (response.data) {
            await this.setState({
              dataTalbe: response.data.welfareList,
              dataTalbeTotalAll: response.data.count,
              loadingFullpage: false,
              loading: false,
              currentPage: 1,
              pagination: {
                total: response.data.count,
              },
            });
          }
        })
        .catch((error) => console.error(`Error: ${error}`));
    });
  };

  handleSubmit = async (e) => {
    const { form, afterSubmit, client } = this.props;
    const { employeeCodes } = this.state;
    await e.preventDefault();
    let dataTalbeArray = [];
    form.validateFields(async (err, values) => {
      await this.setState({
        formValue: e,
        loading: true,
      });

      // await this.fetchLeaveDocumentList(values)
      if (!err) {
        try {
          const { token } = getToken();
          const API_DEVICE_KEY = atob(apiKeyNews());

          const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            apiKey: API_DEVICE_KEY,
          };

          // axios.get(`${UrlAbstainTime()}/getAbstainTimeForApproverList?empCode=${employeeCodes}?searchKeyWord=${null}?status=${values.status ? values.status : ''}`,
          axios
            .get(`${UrlAbstainTime()}/getAbstainTimeForApproverList`, {
              params: {
                empCode: employeeCodes,
                searchKeyword: values.searchKeyWord,
                status: values.status,
              },
              headers: headers,
            })
            .then(async (response) => {
              let dataTalbeArray = [];
              if (response.data.data) {
                await response.data.data.map((valuesList, keys) => {
                  valuesList.statusCheckBox = false;
                  dataTalbeArray.push(valuesList);
                });

                await this.setState({
                  dataTalbe: dataTalbeArray,
                  loadingFullpage: false,
                  loading: false,
                });
              } else {
                await this.setState({
                  preLoadSubmit: false,
                  loadingFullpage: false,
                  loading: false,
                });
              }
            })
            .catch((error) => console.error(`Error: ${error}`));
        } catch (error) {
          console.log("error", error);
        }
      }
    });
  };

  getAbstainTimeForApproverList = async (empCode) => {
    const { token } = getToken();
    const { client, location, match } = this.props;
    const { page, pageSize, disabledDateStart, endStartValues } = this.state;

    console.log("123123,", empCode);
    await this.setState({
      loading: true,
    });

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .get(`${UrlAbstainTime()}/getAbstainTimeForApproverList`, {
        params: {
          empCode,
          status: "pending",
        },
        headers: headers,
      })
      .then(async (response) => {
        let dataTalbeArray = [];
        console.log("response.data.data", response.data.data);
        if (response.data.data) {
          await response.data.data.map((valuesList, keys) => {
            valuesList.statusCheckBox = false;
            dataTalbeArray.push(valuesList);
          });

          await this.setState({
            dataTalbe: dataTalbeArray,
            loadingFullpage: false,
            loading: false,
          });
        } else {
          await this.setState({
            preLoadSubmit: false,
            loadingFullpage: false,
            loading: false,
          });
        }
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  showModalFormConfirm = async (
    status,
    messageForm,
    title,
    textBtnOK,
    ModalFormTextArea,
    ModalFormTextAreaRequie
  ) => {
    const { form, client } = this.props;
    const { dataSelectTable } = this.state;

    this.setState({
      preLoadOnsubmit: true,
    });

    if (dataSelectTable.length !== 0) {
      await this.setState({
        ModalConfirmFormTitle: title,
        ModalConfirmFormSubTitle: "",
        ModalConfirmFormShowModal: true,
        ModalConfirmFormBtnOk: textBtnOK,
        ModalConfirmFormBtnCancel: "ยกเลิก",
        ModalConfirmFormValue: {},
        ModalConfirmFormStatus: status,
        ModalConfirmFormMessage: messageForm,
        ModalFormTextArea,
        ModalFormTextAreaRequie,
      });
    } else {
      let content = "";
      // message.warning('กรุณาเลือกเอกสาร อย่างน้อย 1 รายการ');
      if (status == "REJECT") {
        content = "กรุณาเลือกเอกสารที่ไม่อนุมัติรายการขอเบิก";
      } else if (status == "APPROVE") {
        content = "กรุณาเลือกเอกสารที่จะทำการอนุมัติรายการขอเบิก";
      } else if (status == "MOREINFO") {
        content = "กรุณาเลือกเอกสารที่จะทำการขอเอกสารเพิ่มเติมรายการขอเบิก";
      }

      alertMessage("warning", content);
    }
  };

  hideModalConfirm = async () => {
    await this.setState({
      ModalConfirmFormTitle: null,
      ModalConfirmFormSubTitle: null,
      ModalConfirmFormShowModal: false,
      ModalConfirmFormBtnOk: null,
      ModalConfirmFormBtnCancel: null,
      ModalConfirmFormValue: null,
      ModalConfirmFormStatus: null,
      ModalConfirmFormMessage: null,
    });
  };

  hideModalExportPDF = async () => {
    await this.setState({
      showModalExportPDF: false,
      dateSelectModal: {
        startDate: null,
        endDate: null,
      },
    });
  };

  submitReject = async () => {
    const { dataSelectTable } = this.state;

    if (dataSelectTable.length !== 0) {
      // await this.setToApprover('N', 'ไม่อนุมัติรายการขอลาที่เลือกเรียบร้อย')
      await this.showModalFormConfirm(
        "reject",
        "ไม่อนุมัติรายการแก้ไขการลงเวลาทำงานที่เลือกเรียบร้อย",
        "ท่านไม่อนุมัติรายการแก้ไขการลงเวลาทำงาน",
        "ยืนยัน",
        true,
        true
      );
    } else {
      message.warning({
        content: "กรุณาเลือกเอกสารที่จะไม่อนุมัติรายการแก้ไขการลงเวลาทำงาน",
        key: "1",
        duration: 2,
      });
    }
  };

  submitApprover = async () => {
    const { dataSelectTable } = this.state;

    if (dataSelectTable.length !== 0) {
      // await this.setToApprover('Y', 'ทำการอนุมัติรายการขอลาที่เลือกเรียบร้อย')
      await this.showModalFormConfirm(
        "approve",
        "ทำการอนุมัติรายการแก้ไขการลงเวลาทำงานที่เลือกเรียบร้อย",
        "ท่านต้องการอนุมัติรายการแก้ไขการลงเวลาทำงาน",
        "ยืนยัน",
        true,
        false
      );
    } else {
      message.warning({
        content: "กรุณาเลือกเอกสารที่จะอนุมัติรายการแก้ไขการลงเวลาทำงาน",
        key: "1",
        duration: 2,
      });
    }
  };

  setToApprover = async (values) => {
    const { form, afterSubmit, client } = this.props;
    const {
      dataSelectTable,
      formValue,
      ModalConfirmFormMessage,
      ModalConfirmFormStatus,
      employeeCodes,
    } = this.state;

    let constSelect = dataSelectTable.length;
    let bulk = {};

    try {
      let body = dataSelectTable.map((valuesSelect, keys) => ({
        approverId: valuesSelect.approverId,
        abTimeHdId: valuesSelect.abTimeHdId,
        approveAction: ModalConfirmFormStatus,
        description: values.ModalNoteApprove,
      }));

      bulk = {
        bulk: body,
      };

      const { token } = getToken();
      const API_DEVICE_KEY = atob(apiKeyNews());

      const headers = {
        //"Content-Type": 'multipart/form-data',
        Authorization: `Bearer ${token}`,
        apiKey: API_DEVICE_KEY,
      };

      console.log("123132", bulk);
      axios
        .post(`${UrlAbstainTime()}/multipleApproveAbstainTime`, bulk, {
          headers: headers,
        })
        .then(async (response) => {
          console.log("response", response);
          await this.hideModalConfirm();

          await this.setState({
            dataSelectTable: [],
          });

          alertMessage("success", ModalConfirmFormMessage);
          console.log("formValue", formValue);
          if (formValue) {
            await this.handleSubmit(formValue);
          } else {
            await this.getAbstainTimeForApproverList(employeeCodes);
          }
        })
        .catch((error) => console.error(`Error: ${error}`));
    } catch (error) {
      console.log("error", error);
    }
  };

  exportScholarshipPDF = async () => {
    const { dateSelectModal } = this.state;
    const { client } = this.props;

    console.log("exportSchollarshipPDF");
    if (
      dateSelectModal &&
      dateSelectModal.startDate &&
      dateSelectModal.endDate
    ) {
      try {
        const payDateStart = moment(dateSelectModal?.startDate).format("YYYY-MM-DD");
        const payDateEnd = moment(dateSelectModal?.endDate).format("YYYY-MM-DD");

        const { data } = await client.query({
          query: Queries.fetchUrlTuitionFeesReport,
          variables: {
            studyEducationStatus: "approve",
            startApproveDate: payDateStart,
            endApproveDate: payDateEnd
          },
        });
        if (data.fetchUrlTuitionFeesReport) {
          if (data.fetchUrlTuitionFeesReport?.linkPDF) {
            window.open(data.fetchUrlTuitionFeesReport.linkPDF, "_blank");
            this.hideModalExportPDF()
          } else {
            alertMessage("error", "ไม่พบข้อมูลระหว่างวันที่เลือก");
          }
        }
      } catch {}
    } else {
      alertMessage("error", "กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุด");
    }
  };

  onChangeStatus = async (e) => {
    await this.setState({
      selectStatus: e,
      checkBoxTitle: false,
    });
    await this.onChangeSlectAll(false);
  };

  clearInput = async () => {
    await this.setState({
      pageData: {
        page: 1,
        pageSize: 10,
        valueSearch: null,
      },
      valueSearch: {
        searchKeyword: "",
        welfareStatus: "",
        welfareType: "",
      },
      currentPage: 1,
    });
    await this.props.form.resetFields();

    await this.props.form.setFieldsValue({
      welfareStatus: "",
    });

    await this.listBenefitForApprover();
  };

  geteDropdownDisasterType = async () => {
    const { token } = getToken();
    const { match } = this.props;

    let eiei = [];
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .get(
        `${urlBenefit()}dropdown/get_dropdown_by_type/`,
        {
          params: {
            dropdownType: "WDSStatus",
          },
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("response.data dropdown status", response.data);
        if (response.data) {
          const filterAllowShowStatus = response.data.filter(
            (item) =>
              item.dropdownCode == "pending" ||
              item.dropdownCode == "reject" ||
              item.dropdownCode == "approve" ||
              item.dropdownCode == "cancel"
          );

          await this.setState({
            dropdownWelfareStatus: filterAllowShowStatus,
            //isEdit: response.data.data.approveStatus == "draft" ? true : false,
          });
          //await this.setCondition(response.data);
        }
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  geteDropdownWelfareType = async () => {
    const { token } = getToken();
    const { match } = this.props;
    const { employeeCodes } = this.state;

    let eiei = [];
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .get(
        `${urlBenefit()}dropdown/get_dropdown_by_type/`,
        {
          params: {
            dropdownType: "welfareType",
            empCode: employeeCodes,
            isApprover: true,
          },
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("response.data dropdown status", response.data);
        if (response.data) {
          await this.setState({
            dropdownWelfareType: response.data,
            //isEdit: response.data.data.approveStatus == "draft" ? true : false,
          });
        }
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  handleDateChange = (value, name) => {
    const { dateSelectModal } = this.state;
    console.log("handleDateChange", value, name);

    if (name === "startDate") {
      this.setState({
        dateSelectModal: {
          startDate: value,
          endDate: !value
            ? null
            : moment(value).isAfter(dateSelectModal?.endDate) ||
              !dateSelectModal?.endDate
            ? value
            : dateSelectModal?.endDate,
        },
      });
    } else {
      this.setState({
        dateSelectModal: {
          endDate: value,
          startDate: dateSelectModal.startDate,
        },
      });
    }
  };

  disableEndDate = (current) => {
    const { dateSelectModal } = this.state;
    return (
      dateSelectModal?.startDate &&
      current < dateSelectModal?.startDate?.startOf("day")
    );
  };

  async componentDidMount() {
    await this.setState({
      valueSearch: {
        welfareStatus: "pending",
      },
    });

    await this.fetchProfile();
    await this.listBenefitForApprover();
    await this.geteDropdownDisasterType();
    await this.geteDropdownWelfareType();

    //  await this.fetchDropDownMasterData("course");
    //  await this.fetchDropDownMasterData("leaveResult");
    //  await this.fetchDropDownMasterData("leaveYear");
    //  await this.fetchDropDownMasterData("studyStatus");
    //  await this.getAbstainTimeForApproverList()
    // await this.dropdownLeaveType()
  }

  render() {
    const { match } = this.props;
    const {
      currentPage,
      dataTalbe,
      columns,
      loading,
      pagination,
      valuesEndDate,
      disabledDateStart,
      endStartValues,
      preLoadSubmit,
      dropdownLeaveType,
      ddStartYear,
      ddEndYear,
      loadingFullpage,
      dataSelectTable,
      ModalConfirmFormTitle,
      ModalConfirmFormSubTitle,
      ModalConfirmFormShowModal,
      ModalConfirmFormBtnOk,
      ModalConfirmFormBtnCancel,
      ModalConfirmFormValue,
      ModalFormTextArea,
      ModalFormTextAreaRequie,
      showModalExportPDF,
      valueSearch,
      dateSelectModal,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    console.log("dataSelectTable", dataTalbe);
    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-5">
          {/* <Breadcrumb.Item> */}
          <span style={{ fontSize: "18px" }}>
            เบิกเงินสวัสดิการ / รายการอนุมัติเบิกสวัสดิการ
          </span>
          {/* </Breadcrumb.Item> */}
        </div>

        <Modal
          destroyOnClose={true}
          visible={showModalExportPDF}
          maskClosable={false}
          title="รายงานสรุปเพื่อเตรียมจ่ายเบิกค่าธรรมเนียมการศึกษา"
          // onOk={ () =>{
          //     this.onSubmit()
          // }}
          onCancel={() => {
            this.hideModalExportPDF();
          }}
          width={600}
          okText={"ยืนยัน"}
          cancelText={"ยกเลิก"}
          footer={null}
          className={ModalFormTextArea ? "showTextArrea" : ""}
        >
          <Row gutter={16} type="flex" justify="left" align="top">
            <Col xs={24} md={12}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    fontSize: "15px",
                    color: "#000",
                    marginBottom: "4px",
                  }}
                >
                  ประเภทสวัสดิการ :
                </span>
                <Select
                  style={{ width: "100%" }}
                  value={"Scholarship"}
                  disabled
                >
                  <Option value={""}>ทั้งหมด</Option>
                  {this.state.dropdownWelfareType &&
                    this.state.dropdownWelfareType.map((values, keys) => (
                      <Option value={values.dropdownCode}>
                        {values.dropdownNameTh}
                      </Option>
                    ))}
                </Select>
              </div>
            </Col>

            <Col xs={24} md={12}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    fontSize: "15px",
                    color: "#000",
                    marginBottom: "4px",
                  }}
                >
                  สถานะเอกสาร :
                </span>
                <Select style={{ width: "100%" }} value={"approve"} disabled>
                  <Option value="">ทั้งหมด</Option>
                  {this.state.dropdownWelfareStatus?.map(
                    (valuesLabel, keys) => {
                      return (
                        <Option value={valuesLabel.dropdownCode} key={keys}>
                          {valuesLabel.dropdownNameTh}
                        </Option>
                      );
                    }
                  )}
                </Select>
              </div>
            </Col>

            <Col xs={24} md={12} className="mt-4">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    fontSize: "15px",
                    color: "#000",
                    marginBottom: "4px",
                  }}
                >
                  วันที่เริ่มต้น :
                </span>
                <DatePicker
                  format={changeFormatdate(moment(dateSelectModal.startDate))}
                  value={dateSelectModal.startDate}
                  onChange={(e) => this.handleDateChange(e, "startDate")}
                  placeholder="กรุณาเลือก วันที่เริ่มต้น"
                  label="วันที่เริ่มต้น"
                />
              </div>
            </Col>

            <Col xs={24} md={12} className="mt-4">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    fontSize: "15px",
                    color: "#000",
                    marginBottom: "4px",
                  }}
                >
                  วันที่สิ้นสุด :
                </span>
                <DatePicker
                  format={changeFormatdate(moment(dateSelectModal.endDate))}
                  value={dateSelectModal.endDate}
                  onChange={(e) => this.handleDateChange(e, "endDate")}
                  placeholder="กรุณาเลือก วันที่สิ้นสุด"
                  disabled={!dateSelectModal.startDate}
                  disabledDate={this.disableEndDate}
                  label="วันที่สิ้นสุด"
                />
              </div>
            </Col>
          </Row>
          <Row
            gutter={16}
            type="flex"
            justify="left"
            align="top"
            className="mt-4"
          >
            <Col xs={24} md={24} align={"center"}>
              <Button
                type="primary"
                className="mt-1 mr-3 btn-white-red"
                //disabled={ preLoadOnsubmit }
                // onClick={ this.searchForm }
                onClick={this.hideModalExportPDF}
              >
                ยกเลิก
              </Button>

              <Button
                type="primary"
                className="mt-1 color-white"
                htmlType="submit"
                onClick={this.exportScholarshipPDF}
                //disabled={ preLoadOnsubmit }
              >
                ดาวน์โหลด
              </Button>
            </Col>
          </Row>
        </Modal>

        <ModalConfirmForm
          title={ModalConfirmFormTitle}
          subtitle={ModalConfirmFormSubTitle}
          showModal={ModalConfirmFormShowModal}
          btnOk={ModalConfirmFormBtnOk}
          btnCancel={ModalConfirmFormBtnCancel}
          submitToSend={this.setToApprover}
          hideModal={this.hideModalConfirm}
          valueConfirm={ModalConfirmFormValue}
          ModalFormTextArea={ModalFormTextArea}
          ModalFormTextAreaRequie={ModalFormTextAreaRequie}
        />
        <Spin spinning={loadingFullpage} delay={0}>
          <div className="card-container" id="page-profile">
            <div className="px-5 py-1 card-bg-green">
              <Form ref={this.formRef} onSubmit={this.listBenefitForApproverSearchPagi}>
                <Row
                  gutter={16}
                  type="flex"
                  justify="left"
                  align="top"
                  className="box-color-white mb-0"
                >
                  <Col xs={24} md={24} className="pt-2  mb-3">
                    <strong className="color-red">ค้นหา</strong>
                  </Col>
                  <Collapse style={{ width: "100%" }}>
                    <Panel header="ค้นหา" key="1">
                      <Form
                        onSubmit={this.listBenefitForStaffSearchPagi}
                        className="px-4"
                      >
                        <Row
                          gutter={16}
                          type="flex"
                          justify="left"
                          align="top"
                          className="pb-2"
                        >
                          <Col xs={24} md={8}>
                            <Form.Item label={"เลขที่เอกสาร"} className="mb-0">
                              {getFieldDecorator("searchKeyword", {
                                initialValue: "",
                              })(<Input className="block-news" />)}
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={8}>
                            <Form.Item
                              label={"ประเภทสวัสดิการ"}
                              className="mb-0"
                            >
                              {getFieldDecorator("welfareType", {
                                initialValue: "",
                              })(
                                <Select style={{ width: "100%" }}>
                                  <Option value={""}>ทั้งหมด</Option>
                                  {this.state.dropdownWelfareType &&
                                    this.state.dropdownWelfareType.map(
                                      (values, keys) => (
                                        <Option value={values.dropdownCode}>
                                          {values.dropdownNameTh}
                                        </Option>
                                      )
                                    )}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={8}>
                            <Form.Item label={"สถานะ"} className="mb-0">
                              {getFieldDecorator("welfareStatus", {
                                initialValue: "pending",
                              })(
                                <Select style={{ width: "100%" }}>
                                  <Option value="">ทั้งหมด</Option>
                                  {this.state.dropdownWelfareStatus?.map(
                                    (valuesLabel, keys) => {
                                      return (
                                        <Option
                                          value={valuesLabel.dropdownCode}
                                          key={keys}
                                        >
                                          {valuesLabel.dropdownNameTh}
                                        </Option>
                                      );
                                    }
                                  )}
                                </Select>
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row
                          gutter={16}
                          type="flex"
                          justify="left"
                          align="top"
                          className=" mt-3"
                        >
                          <Col xs={24} md={24} align={"right"}>
                            <Button
                              type="primary"
                              className="mx-2 btn-white-red"
                              onClick={this.clearInput}
                            >
                              ล้างค่า
                            </Button>
                            <Button
                              type="primary"
                              id="btn-onsearch"
                              className="color-white"
                              htmlType="submit"
                              disabled={preLoadSubmit}
                            >
                              ค้นหา
                            </Button>
                            {preLoadSubmit && <Spin size="small" />}
                          </Col>
                        </Row>
                      </Form>
                    </Panel>
                  </Collapse>
                </Row>
              </Form>
            </div>
            <div className="px-5 py-1 card-bg-green">
              <Row
                gutter={16}
                type="flex"
                justify="left"
                align="top"
                className="box-color-white"
              >
                <Col xs={24} md={12} className="pt-2 mb-3">
                  <strong className="color-red">
                    รายการอนุมัติเบิกสวัสดิการ
                  </strong>
                </Col>
                {valueSearch?.welfareType &&
                  valueSearch?.welfareStatus &&
                  valueSearch?.welfareType?.toLowerCase() === "scholarship" &&
                  valueSearch?.welfareStatus?.toLowerCase() === "approve" && (
                    <Col xs={24} md={12} className="pb-2" align="right">
                      <Button
                        type="primary"
                        className="ml-2 color-white btn-green custom-export"
                        htmlType="submit"
                        onClick={() =>
                          this.setState({
                            showModalExportPDF: true,
                          })
                        }
                      >
                        <Icon type="file-text" /> รายงานสรุปเพื่อเตรียมจ่าย
                      </Button>
                      {/* <span style={{ fontSize:"13px" }}>
                                  จำนวนทั้งหมดของรายการอนุมัติ { dataTalbe.length }
                                </span> */}
                    </Col>
                  )}

                <Col xs={24} md={24} align={"center"}>
                  {
                    <Table
                      locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                      dataSource={dataTalbe}
                      columns={columns}
                      loading={loading}
                      // scroll={{ x: 'max-content' }}
                      // pagination={pagination}
                      // pagination={{ pageSize: dataTalbe.length }}
                      scroll={{ x: 1300 }}
                      pagination={{
                        total: pagination.total,
                        current: currentPage,
                        showSizeChanger: false,
                      }}
                      onChange={this.paginationChange}
                      // onChange={this.paginationChange}
                      // rowCount={dataTalbe.length}
                    />
                  }
                </Col>

                {/* <Col xs={24} md={24} align={"center"} className="mt-4">
                  <Button
                    type="primary"
                    className="mx-2 btn-white-red"
                    htmlType="submit"
                    onClick={this.submitReject}
                  >
                    ไม่อนุมัติ
                  </Button>
                  <Button
                    type="primary"
                    className="ml-2 color-white btn-green"
                    htmlType="submit"
                    onClick={this.submitApprover}
                  >
                    อนุมัติ
                  </Button>
                </Col> */}
              </Row>
            </div>
          </div>
        </Spin>
      </Container>
    );
  }
}

Dashboard.defaultProps = {
  autoFocus: false,
};

Dashboard.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedDashboard = Form.create()(Dashboard);

export default withApollo(WrappedDashboard);
